import { FaSnapchatSquare } from "react-icons/fa";
import {
  FaMeta,
  FaGoogle,
  FaXTwitter,
  FaInstagram,
  FaWhatsapp,
} from "react-icons/fa6";
import { GrResources } from "react-icons/gr";
export const colorPalettes = [
  { backgroundColor: "#F0A6CA", borderColor: "#E382A6" }, // Pink
  { backgroundColor: "#B4E2E3", borderColor: "#82C9CA" }, // Light Blue
  { backgroundColor: "#C9B5E2", borderColor: "#A688CA" }, // Lavender
  { backgroundColor: "#FFE0C6", borderColor: "#FFBC82" }, // Peach
  { backgroundColor: "#FFB4B4", borderColor: "#FF8282" }, // Pastel Red
  { backgroundColor: "#B4CCE2", borderColor: "#82AACA" }, // Sky Blue
  { backgroundColor: "#B8E2CF", borderColor: "#82CAAD" }, // Aquamarine
  { backgroundColor: "#D3A6E2", borderColor: "#B382CA" }, // Orchid
  { backgroundColor: "#B4D8B8", borderColor: "#82BFA1" }, // Light Green
  { backgroundColor: "#F1DCA7", borderColor: "#E2BA82" }, // Light Yellow
  { backgroundColor: "#A6E2C1", borderColor: "#82CAA1" }, // Mint Green
  { backgroundColor: "#FFD1B4", borderColor: "#FFAF82" }, // Light Orange
  { backgroundColor: "#FFE9B4", borderColor: "#FFD082" }, // Pale Yellow
  { backgroundColor: "#F0C6E2", borderColor: "#E282CA" }, // Pinkish Purple
  { backgroundColor: "#A6E2DF", borderColor: "#82CAC4" }, // Turquoise
  { backgroundColor: "#B5C6E2", borderColor: "#829BCA" }, // Baby Blue
  { backgroundColor: "#E2A6A6", borderColor: "#CA8282" }, // Light Coral
  { backgroundColor: "#FFE7E0", borderColor: "#FFBAA6" }, // Pale Pink
  { backgroundColor: "#B4E2D7", borderColor: "#82CAC1" }, // Seafoam Green
  { backgroundColor: "#F0E2A6", borderColor: "#E2CA82" }, // Pale Gold
];

export const colorArray = [
  { bg: "#EAE6FC", text: "#5332E6" },
  { bg: "#FFE8AA", text: "#805D00" },
  { bg: "#DBF6F8", text: "#1D8E99" },
  { bg: "#FCE2F2", text: "#C2137B" },
  { bg: "#DFF0FF", text: "#025EAD" },
  { bg: "#D4F5E1", text: "#006541" },
];

// Reporting modules (duplicated enum values; keep in sync with ReportModuleEnum)
export const REPORT_MODULES = [
  { label: 'Leads', value: 'LEAD' },
  { label: 'Activities', value: 'ACTIVITY' },
  { label: 'Todos', value: 'TODO' },
  { label: 'Approval Requests', value: 'APPROVAL_REQUEST' },
];
export const defaultTaskTypes = [
  { _id: "id_call", name: "CALL", value: "CALL" },
  { _id: "id_mail", name: "MAIL", value: "MAIL" },
  {
    _id: "id_meeting",
    name: "MEETING",
    value: "MEETING",
  },
];
export const taskPriorities: string[] = ["LOW", "MEDIUM", "HIGH"];

export const taskReminderOptions = [
  { label: "15 minutes before", value: "FIFTEEN_MINUTES" },
  { label: "30 minutes before", value: "THIRTY_MINUTES" },
  { label: "1 hour before", value: "ONE_HOUR" },
  { label: "2 hours before", value: "TWO_HOURS" },
  { label: "1 day before", value: "ONE_DAY" },
];

export enum TodoStatusEnum {
  OVERDUE = "OVERDUE",
  UPCOMING = "UPCOMING",
  COMPLETED = "COMPLETED",
  TODAY = "TODAY",
}

export const sourceIcons: any[] = [
  { label: "Meta", value: "meta", asset: FaMeta, color: "#0081fb" },
  { label: "Google", value: "google", asset: FaGoogle, color: "#EA4335" },
  { label: "Twitter", value: "twitter", asset: FaXTwitter, color: "#000000" },
  {
    label: "Instagram",
    value: "instagram",
    asset: FaInstagram,
    color: "#dd2a7b",
  },
  {
    label: "Snapchat",
    value: "snapchat",
    asset: FaSnapchatSquare,
    color: "#fffc00",
  },
  { label: "Whatsapp", value: "whatsapp", asset: FaWhatsapp, color: "#25D366" },
  { label: "Other", value: "other", asset: GrResources, color: "#a6a6a6" },
];

export const countryCodeList = [
  { name: "India (+91)", label: "+91", value: "91" },
  { name: "Afghanistan (+93)", label: "+93", value: "93" },
  { name: "Aland Islands (+358)", label: "+358", value: "358" },
  { name: "Albania (+355)", label: "+355", value: "355" },
  { name: "Algeria (+213)", label: "+213", value: "213" },
  { name: "American Samoa (+1684)", label: "+1684", value: "1684" },
  { name: "Andorra (+376)", label: "+376", value: "376" },
  { name: "Angola (+244)", label: "+244", value: "244" },
  { name: "Anguilla (+1264)", label: "+1264", value: "1264" },
  { name: "Antigua and Barbuda (+1268)", label: "+1268", value: "1268" },
  { name: "Argentina (+54)", label: "+54", value: "54" },
  { name: "Armenia (+374)", label: "+374", value: "374" },
  { name: "Aruba (+297)", label: "+297", value: "297" },
  { name: "Australia (+61)", label: "+61", value: "61" },
  { name: "Austria (+43)", label: "+43", value: "43" },
  { name: "Azerbaijan (+994)", label: "+994", value: "994" },
  { name: "Bahamas (+1242)", label: "+1242", value: "1242" },
  { name: "Bahrain (+973)", label: "+973", value: "973" },
  { name: "Bangladesh (+880)", label: "+880", value: "880" },
  { name: "Barbados (+1246)", label: "+1246", value: "1246" },
  { name: "Belarus (+375)", label: "+375", value: "375" },
  { name: "Belgium (+32)", label: "+32", value: "32" },
  { name: "Belize (+501)", label: "+501", value: "501" },
  { name: "Benin (+229)", label: "+229", value: "229" },
  { name: "Bermuda (+1441)", label: "+1441", value: "1441" },
  { name: "Bhutan (+975)", label: "+975", value: "975" },
  { name: "Bolivia (+591)", label: "+591", value: "591" },
  { name: "Bosnia and Herzegovina (+387)", label: "+387", value: "387" },
  { name: "Botswana (+267)", label: "+267", value: "267" },
  { name: "Brazil (+55)", label: "+55", value: "55" },
  {
    name: "British Indian Ocean Territory (+246)",
    label: "+246",
    value: "246",
  },
  { name: "Brunei (+673)", label: "+673", value: "673" },
  { name: "Bulgaria (+359)", label: "+359", value: "359" },
  { name: "Burkina Faso (+226)", label: "+226", value: "226" },
  { name: "Burundi (+257)", label: "+257", value: "257" },
  { name: "Cambodia (+855)", label: "+855", value: "855" },
  { name: "Cameroon (+237)", label: "+237", value: "237" },
  { name: "Cape Verde (+238)", label: "+238", value: "238" },
  { name: "Cayman Islands (+345)", label: "+345", value: "345" },
  { name: "Central African Republic (+236)", label: "+236", value: "236" },
  { name: "Chad (+235)", label: "+235", value: "235" },
  { name: "Chile (+56)", label: "+56", value: "56" },
  { name: "China (+86)", label: "+86", value: "86" },
  { name: "Colombia (+57)", label: "+57", value: "57" },
  { name: "Comoros (+269)", label: "+269", value: "269" },
  { name: "Congo (+242)", label: "+242", value: "242" },
  {
    name: "Congo, Democratic Republic of the Congo (+243)",
    label: "+243",
    value: "243",
  },
  { name: "Cook Islands (+682)", label: "+682", value: "682" },
  { name: "Costa Rica (+506)", label: "+506", value: "506" },
  { name: "Cote d'Ivoire (+225)", label: "+225", value: "225" },
  { name: "Croatia (+385)", label: "+385", value: "385" },
  { name: "Cuba (+53)", label: "+53", value: "53" },
  { name: "Cyprus (+357)", label: "+357", value: "357" },
  { name: "Czech Republic (+420)", label: "+420", value: "420" },
  { name: "Denmark (+45)", label: "+45", value: "45" },
  { name: "Djibouti (+253)", label: "+253", value: "253" },
  { name: "Dominica (+1767)", label: "+1767", value: "1767" },
  { name: "Dominican Republic (+1849)", label: "+1849", value: "1849" },
  { name: "Ecuador (+593)", label: "+593", value: "593" },
  { name: "Egypt (+20)", label: "+20", value: "20" },
  { name: "El Salvador (+503)", label: "+503", value: "503" },
  { name: "Equatorial Guinea (+240)", label: "+240", value: "240" },
  { name: "Eritrea (+291)", label: "+291", value: "291" },
  { name: "Estonia (+372)", label: "+372", value: "372" },
  { name: "Ethiopia (+251)", label: "+251", value: "251" },
  { name: "Falkland Islands (Malvinas) (+500)", label: "+500", value: "500" },
  { name: "Faroe Islands (+298)", label: "+298", value: "298" },
  { name: "Fiji (+679)", label: "+679", value: "679" },
  { name: "France (+33)", label: "+33", value: "33" },
  { name: "French Guiana (+594)", label: "+594", value: "594" },
  { name: "French Polynesia (+689)", label: "+689", value: "689" },
  { name: "Gabon (+241)", label: "+241", value: "241" },
  { name: "Gambia (+220)", label: "+220", value: "220" },
  { name: "Georgia (+995)", label: "+995", value: "995" },
  { name: "Germany (+49)", label: "+49", value: "49" },
  { name: "Ghana (+233)", label: "+233", value: "233" },
  { name: "Gibraltar (+350)", label: "+350", value: "350" },
  { name: "Greece (+30)", label: "+30", value: "30" },
  { name: "Greenland (+299)", label: "+299", value: "299" },
  { name: "Grenada (+1473)", label: "+1473", value: "1473" },
  { name: "Guadeloupe & Saint Barthelemy (+590)", label: "+590", value: "590" },
  { name: "Guam (+1671)", label: "+1671", value: "1671" },
  { name: "Guatemala (+502)", label: "+502", value: "502" },
  { name: "Guinea (+224)", label: "+224", value: "224" },
  { name: "Guinea-Bissau (+245)", label: "+245", value: "245" },
  { name: "Guyana & Paraguay (+595)", label: "+595", value: "595" },
  { name: "Haiti (+509)", label: "+509", value: "509" },
  { name: "Holy See (Vatican City State) (+379)", label: "+379", value: "379" },
  { name: "Honduras (+504)", label: "+504", value: "504" },
  { name: "Hong Kong (+852)", label: "+852", value: "852" },
  { name: "Hungary (+36)", label: "+36", value: "36" },
  { name: "Iceland (+354)", label: "+354", value: "354" },
  { name: "Indonesia (+62)", label: "+62", value: "62" },
  {
    name: "Iran, Islamic Republic of Persian Gulf (+98)",
    label: "+98",
    value: "98",
  },
  { name: "Iraq (+964)", label: "+964", value: "964" },
  { name: "Ireland (+353)", label: "+353", value: "353" },
  { name: "Israel (+972)", label: "+972", value: "972" },
  { name: "Italy (+39)", label: "+39", value: "39" },
  { name: "Jamaica (+1876)", label: "+1876", value: "1876" },
  { name: "Japan (+81)", label: "+81", value: "81" },
  { name: "Jordan (+962)", label: "+962", value: "962" },
  { name: "Kazakhstan (+77)", label: "+77", value: "77" },
  { name: "Kenya (+254)", label: "+254", value: "254" },
  { name: "Kiribati (+686)", label: "+686", value: "686" },
  {
    name: "Korea, Democratic People's Republic of Korea (+850)",
    label: "+850",
    value: "850",
  },
  { name: "Korea, Republic of South Korea (+82)", label: "+82", value: "82" },
  { name: "Kuwait (+965)", label: "+965", value: "965" },
  { name: "Kyrgyzstan (+996)", label: "+996", value: "996" },
  { name: "Laos (+856)", label: "+856", value: "856" },
  { name: "Latvia (+371)", label: "+371", value: "371" },
  { name: "Lebanon (+961)", label: "+961", value: "961" },
  { name: "Lesotho (+266)", label: "+266", value: "266" },
  { name: "Liberia (+231)", label: "+231", value: "231" },
  { name: "Libya (+218)", label: "+218", value: "218" },
  { name: "Liechtenstein (+423)", label: "+423", value: "423" },
  { name: "Lithuania (+370)", label: "+370", value: "370" },
  { name: "Luxembourg (+352)", label: "+352", value: "352" },
  { name: "Macao (+853)", label: "+853", value: "853" },
  { name: "Macedonia (+389)", label: "+389", value: "389" },
  { name: "Madagascar (+261)", label: "+261", value: "261" },
  { name: "Malawi (+265)", label: "+265", value: "265" },
  { name: "Malaysia (+60)", label: "+60", value: "60" },
  { name: "Maldives (+960)", label: "+960", value: "960" },
  { name: "Mali (+223)", label: "+223", value: "223" },
  { name: "Malta (+356)", label: "+356", value: "356" },
  { name: "Marshall Islands (+692)", label: "+692", value: "692" },
  { name: "Martinique (+596)", label: "+596", value: "596" },
  { name: "Mauritania (+222)", label: "+222", value: "222" },
  { name: "Mauritius (+230)", label: "+230", value: "230" },
  { name: "Mexico (+52)", label: "+52", value: "52" },
  {
    name: "Micronesia, Federated States of Micronesia (+691)",
    label: "+691",
    value: "691",
  },
  { name: "Moldova (+373)", label: "+373", value: "373" },
  { name: "Monaco (+377)", label: "+377", value: "377" },
  { name: "Mongolia (+976)", label: "+976", value: "976" },
  { name: "Montenegro (+382)", label: "+382", value: "382" },
  { name: "Montserrat (+1664)", label: "+1664", value: "1664" },
  { name: "Morocco (+212)", label: "+212", value: "212" },
  { name: "Mozambique (+258)", label: "+258", value: "258" },
  { name: "Myanmar (+95)", label: "+95", value: "95" },
  { name: "Namibia (+264)", label: "+264", value: "264" },
  { name: "Nauru (+674)", label: "+674", value: "674" },
  { name: "Nepal (+977)", label: "+977", value: "977" },
  { name: "Netherlands (+31)", label: "+31", value: "31" },
  { name: "Netherlands Antilles (+599)", label: "+599", value: "599" },
  { name: "New Caledonia (+687)", label: "+687", value: "687" },
  { name: "New Zealand (+64)", label: "+64", value: "64" },
  { name: "Nicaragua (+505)", label: "+505", value: "505" },
  { name: "Niger (+227)", label: "+227", value: "227" },
  { name: "Nigeria (+234)", label: "+234", value: "234" },
  { name: "Niue (+683)", label: "+683", value: "683" },
  { name: "Norfolk Island (+672)", label: "+672", value: "672" },
  { name: "Northern Mariana Islands (+1670)", label: "+1670", value: "1670" },
  { name: "Norway (+47)", label: "+47", value: "47" },
  { name: "Oman (+968)", label: "+968", value: "968" },
  { name: "Pakistan (+92)", label: "+92", value: "92" },
  { name: "Palau (+680)", label: "+680", value: "680" },
  {
    name: "Palestinian Territory, Occupied (+970)",
    label: "+970",
    value: "970",
  },
  { name: "Panama (+507)", label: "+507", value: "507" },
  { name: "Papua New Guinea (+675)", label: "+675", value: "675" },
  { name: "Peru (+51)", label: "+51", value: "51" },
  { name: "Philippines (+63)", label: "+63", value: "63" },
  { name: "Pitcairn (+872)", label: "+872", value: "872" },
  { name: "Poland (+48)", label: "+48", value: "48" },
  { name: "Portugal (+351)", label: "+351", value: "351" },
  { name: "Puerto Rico (+1939)", label: "+1939", value: "1939" },
  { name: "Qatar (+974)", label: "+974", value: "974" },
  { name: "Romania (+40)", label: "+40", value: "40" },
  { name: "Russia (+7)", label: "+7", value: "7" },
  { name: "Rwanda (+250)", label: "+250", value: "250" },
  { name: "Saint Helena (+290)", label: "+290", value: "290" },
  { name: "Saint Kitts and Nevis (+1869)", label: "+1869", value: "1869" },
  { name: "Saint Lucia (+1758)", label: "+1758", value: "1758" },
  { name: "Saint Pierre and Miquelon (+508)", label: "+508", value: "508" },
  {
    name: "Saint Vincent and the Grenadines (+1784)",
    label: "+1784",
    value: "1784",
  },
  { name: "Samoa (+685)", label: "+685", value: "685" },
  { name: "San Marino (+378)", label: "+378", value: "378" },
  { name: "Sao Tome and Principe (+239)", label: "+239", value: "239" },
  { name: "Saudi Arabia (+966)", label: "+966", value: "966" },
  { name: "Senegal (+221)", label: "+221", value: "221" },
  { name: "Serbia (+381)", label: "+381", value: "381" },
  { name: "Seychelles (+248)", label: "+248", value: "248" },
  { name: "Sierra Leone (+232)", label: "+232", value: "232" },
  { name: "Singapore (+65)", label: "+65", value: "65" },
  { name: "Slovakia (+421)", label: "+421", value: "421" },
  { name: "Slovenia (+386)", label: "+386", value: "386" },
  { name: "Solomon Islands (+677)", label: "+677", value: "677" },
  { name: "Somalia (+252)", label: "+252", value: "252" },
  { name: "South Africa (+27)", label: "+27", value: "27" },
  { name: "South Sudan (+211)", label: "+211", value: "211" },
  { name: "Spain (+34)", label: "+34", value: "34" },
  { name: "Sri Lanka (+94)", label: "+94", value: "94" },
  { name: "Sudan (+249)", label: "+249", value: "249" },
  { name: "Suriname (+597)", label: "+597", value: "597" },
  { name: "Swaziland (+268)", label: "+268", value: "268" },
  { name: "Sweden (+46)", label: "+46", value: "46" },
  { name: "Switzerland (+41)", label: "+41", value: "41" },
  { name: "Syrian Arab Republic (+963)", label: "+963", value: "963" },
  { name: "Taiwan (+886)", label: "+886", value: "886" },
  { name: "Tajikistan (+992)", label: "+992", value: "992" },
  { name: "Tanzania (+255)", label: "+255", value: "255" },
  { name: "Thailand (+66)", label: "+66", value: "66" },
  { name: "Togo (+228)", label: "+228", value: "228" },
  { name: "Tokelau (+690)", label: "+690", value: "690" },
  { name: "Tonga (+676)", label: "+676", value: "676" },
  { name: "Trinidad and Tobago (+1868)", label: "+1868", value: "1868" },
  { name: "Tunisia (+216)", label: "+216", value: "216" },
  { name: "Turkey (+90)", label: "+90", value: "90" },
  { name: "Turkmenistan (+993)", label: "+993", value: "993" },
  { name: "Turks and Caicos Islands (+1649)", label: "+1649", value: "1649" },
  { name: "Tuvalu (+688)", label: "+688", value: "688" },
  { name: "Uganda (+256)", label: "+256", value: "256" },
  { name: "Ukraine (+380)", label: "+380", value: "380" },
  { name: "United Arab Emirates (+971)", label: "+971", value: "971" },
  { name: "United Kingdom & Guernsey (+44)", label: "+44", value: "44" },
  { name: "United States & Canada (+1)", label: "+1", value: "1" },
  { name: "Uruguay (+598)", label: "+598", value: "598" },
  { name: "Uzbekistan (+998)", label: "+998", value: "998" },
  { name: "Vanuatu (+678)", label: "+678", value: "678" },
  { name: "Venezuela (+58)", label: "+58", value: "58" },
  { name: "Vietnam (+84)", label: "+84", value: "84" },
  { name: "Virgin Islands, British (+1284)", label: "+1284", value: "1284" },
  { name: "Virgin Islands, U.S. (+1340)", label: "+1340", value: "1340" },
  { name: "Wallis and Futuna (+681)", label: "+681", value: "681" },
  { name: "Yemen (+967)", label: "+967", value: "967" },
  { name: "Zambia (+260)", label: "+260", value: "260" },
  { name: "Zimbabwe (+263)", label: "+263", value: "263" },
];

export const phoneTypes = [
  { name: "PERSONAL" },
  { name: "WHATSAPP" },
  { name: "OFFICE" },
  { name: "OTHER" },
];
export const emailTypes = [
  { name: "PERSONAL" },
  { name: "OFFICE" },
  { name: "OTHER" },
];

export const userDataType = ["SUPER_ADMIN", "ADMIN", "MANAGER", "EXECUTIVE"];

export const userRoles = [
  { id: "645b78ba7fe6b46536116878", label: "Admin" },
  { id: "645b78ef7fe6b4653611687a", label: "Manager" },
  { id: "645b78ff7fe6b4653611687b", label: "Executive" },
];

export const getRoleOptions = () =>  userRoles.map(role => ({ value: role.id, label: role.label }));

export const defaultPermissions: any = [];

export const API_KEY = "459e1376-ea68-11ed-a05b-0242ac120003";
